import React from 'react';
import { Box, Typography } from '@mui/material';
import { Button } from 'framework/ui/mui-builder';
import { TextArea, DateInput, useFormContext } from 'framework/form';
import { useDateService } from 'framework/utils';

interface HealthcheckFormContentProps {
  onClose: () => void;
}

const HealthcheckFormContent: React.FC<HealthcheckFormContentProps> = ({ onClose }) => {
  const { getToday } = useDateService();
  const { submitForm, isSubmitEnabled } = useFormContext();

  return (
    <Box>
      <Typography variant="h3" sx={{ mb: 2 }}>
        System health check
      </Typography>

      <Box>
        <DateInput source="date" label="Healthcheck date" maxDate={getToday()} />
      </Box>

      <Box sx={{ mb: 2 }}>
        <TextArea source="description" label="Description" placeholder="Enter healthcheck description" />
      </Box>

      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', mt: 3 }}>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button color="primary" variant="contained" onClick={submitForm} disabled={!isSubmitEnabled}>
          Submit
        </Button>
      </Box>
    </Box>
  );
};

export default HealthcheckFormContent;
